import React from 'react';
import { AlertCircle } from 'lucide-react';

export function HelpTroubleshooting({ items }) {
  return (
    <div className="space-y-4">
      {items.map((item, i) => (
        <div key={i} className="border border-slate-200 rounded-xl p-4">
          <div className="flex items-start gap-2.5 mb-2">
            <AlertCircle size={16} className="flex-shrink-0 text-amber-500 mt-0.5" />
            <p className="font-semibold text-slate-800 text-sm">{item.problem}</p>
          </div>
          <p className="text-sm text-slate-600 leading-relaxed pl-6">{item.solution}</p>
        </div>
      ))}
    </div>
  );
}
